import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import IabCategoriesFilterResult from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/IabCategoriesFilter/IabCategoriesFilterResult";
import IabCategoriesFilterView from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/IabCategoriesFilter/IabCategoriesFilterView";
import IabCategoriesFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/IabCategoriesFilter/IabCategoriesFilter";
import type { FindAppsDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsCommonFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";

function createIabCategoriesFilter(description: FindAppsDescriptionDto): IFilterInstance<IAppsCommonFiltersDto> {
    return {
        key: "iabCategories",
        trackingName: "App IAB Categories",
        title: { key: "si.find_apps.filters.iab-categories.title" },
        tooltipText: { key: "si.find_apps.filters.iab-categories.tooltip" },
        filter: new IabCategoriesFilter({
            options: description.iabCategories,
        }),
        filterView: IabCategoriesFilterView,
        filterResultView: IabCategoriesFilterResult,
    };
}

export default createIabCategoriesFilter;
